import Modal from '../../mini/Modal'
import React, { useEffect, useState } from 'react'
import { LinkedAccount, ModalStyles } from './styled'
import { P2, P3, Caption1, Input } from '../../styled/typography/typography'
import Button from '../../mini/Button'
import Password from '../../mini/Password'
import validateEmailRequest, { createGuardianUser } from './API'
import { hideModal, showModal } from '../../../actions/_modal'
import { useDispatch } from 'react-redux'

const CreateGuardianModal = ({ response, token }) => {
  const dispatch = useDispatch()
  const [email, setEmail] = useState()
  const [emailErrors, setEmailErrors] = useState({ invalid: false, email_in_use: false, existing_mentor_or_student_account: false })
  const [emailBEValidated, setEmailBEValidated] = useState(true)
  const [password, setPassword] = useState('')
  const [creatingAccount, setCreatingAccount] = useState(false)
  const [confirmedPassword, setConfirmedPassword] = useState('')
  const [passwordError, setPasswordError] = useState(false)
  const [passwordLengthError, setPasswordLengthError] = useState(false)

  useEffect(async () => {
    setEmailErrors(state => ({
      ...state,
      email_in_use: response.email_in_use,
      existing_mentor_or_student_account: response.existing_mentor_or_student_account
    }))
    setEmail(response.default_email)

  }, [response])

  const goToLink = () => {
    dispatch(hideModal())
    dispatch(showModal('GUARDIAN_LINK_ACCOUNT', { response, token }))
  }

   const validateEmail = (email) => {
    const regEx = /\S+@\S+\.\S+/
    return regEx.test(email)
  }

  const handleEmailBlur = async email => {
    const validated = validateEmail(email)
    if (validated) {
      const result = await validateEmailRequest(email)
      setEmailBEValidated(true)
      setEmailErrors(state => ({ ...state, ...result }))
    } else {
      setEmailErrors(state => ({ ...state, invalid: true }))
    }
  }

  const handleEmailChange = e => {
    setEmail(e.target.value)
    setEmailBEValidated(false)

    if (emailErrors.invalid && validateEmail(e.target.value)) {
      setEmailErrors(state => ({...state, invalid: false}))
    }

    if (emailErrors.existing_mentor_or_student_account) {
      setEmailErrors(state => ({...state, existing_mentor_or_student_account: false}))
    }

    if (emailErrors.email_in_use) {
      setEmailErrors(state => ({...state, email_in_use: false}))
    }
  }

  const handlePasswordChange = e => {
    validatePassword(e.target.value)
    setPassword(e.target.value)
  }

  const handlePasswordConfirmChange = e => {
    validateConfirmPassword(e.target.value)
    setConfirmedPassword(e.target.value)
  }

  const validatePassword = e => {
    if (confirmedPassword !== e) {
      setPasswordError(true)
    } else {
      setPasswordError(false)
    }
  }

  const validateConfirmPassword = e => {
    if (password !== e) {
      setPasswordError(true)
    } else {
      setPasswordError(false)
    }
  }

  const validatePasswordLength = () => {
    if (password.length >= 8) {
      setPasswordLengthError(false)
    } else {
      setPasswordLengthError(true)
    }
  }

  const createGuardian = async (email, password, token) => {
    setCreatingAccount(true)
    const create = await createGuardianUser(email, password, token)

    if (create instanceof Error) {
      dispatch(hideModal())
      dispatch(showModal('GUARDIAN_ACCOUNT_ERROR', { response, token }))
    } else {
      dispatch(hideModal())
      dispatch(showModal('GUARDIAN_ACCOUNT_SUCCESS', {}))
    }
  }

  const checkForEmailError = () => Object.values(emailErrors).includes(true)

  const displayPolicies = () => {
    dispatch(hideModal())
    dispatch(showModal('OUR_POLICIES', { response, token }))
  }

  const shouldButtonBeDisabled = () => {
    const correctPasswordLength = () => password.length > 7 && confirmedPassword.length > 7
    const equalP = () => password === confirmedPassword
    const errors = [
      !checkForEmailError(),
      validateEmail(email),
      !passwordError,
      correctPasswordLength(),
      equalP(),
      !creatingAccount,
      emailBEValidated
    ]

    return errors.includes(false)
  }

  return (
    <Modal
      width={472}
      topPx={480}
      allowOverflow
      allowOuterScroll
      overlayHeight={'100vh'}
      background={'transparent'}
      opacity={'1'}
      boxShadow={'0 0 30px 0 rgba(0,0,0,0.07)'}
      position={'absolute'}
    >
      <ModalStyles>
        <P2 className="header">Create an account to view {response.student_name}'s workspace or link to an existing account below.
        </P2>
        <P2 className="input-label">Email</P2>
        <Input
          type="email"
          autocomplete="off"
          onChange={handleEmailChange}
          onBlur={() => handleEmailBlur(email)}
          defaultValue={response.default_email}
        />
        {emailErrors.invalid &&
          <P2 className="error">Please enter a valid email address.</P2>
        }
        {emailErrors.email_in_use && !emailErrors.existing_mentor_or_student_account &&
          <P2 className="error">This email is already in use.</P2>
        }
        {emailErrors.email_in_use && emailErrors.existing_mentor_or_student_account &&
          <P2 className="error">This email is already used for a mentor or student account.
            Please create a guardian account with a different email.
          </P2>
        }
        <div>
          <P2 className="input-label">Password</P2>
          <Password
            type="password"
            onChange={(e) => handlePasswordChange(e)}
            onBlur={validatePasswordLength}
            placeholder="Password"
            id="guardian-password"
          />
          <Caption1 className={passwordLengthError ? "error" : "helper"}>Minimum of 8 characters.</Caption1>
        </div>

        <P2 className="input-label">Confirm Password</P2>
        <Password
          type="password"
          onChange={(e) => handlePasswordConfirmChange(e)}
          placeholder="Confirm Password"
          id="guardian-confirm"
        />
        {passwordError &&
          <P2 className="error">Please provide matching passwords.</P2>
        }
        <P3 className="policy">By creating an account, you agree to <span className="link" onClick={() => displayPolicies()}>Our Policies</span>,
          including the End User Agreement, Privacy Policy, and the Terms and Conditions.
        </P3>
        <Button
          text="Create Account"
          className={`quest-btn btn-a go uncap ${
            shouldButtonBeDisabled() ? 'disabled' : 'active'} 
            ${creatingAccount && 'no-animate'}`}
          onClick={
            !shouldButtonBeDisabled()
              ? () => createGuardian(email, password, token)
              : null
          }
        />
      </ModalStyles>
      <LinkedAccount onClick={goToLink}>
        <p>Already have an account with another student? <span className="link">Link it here.</span> </p>
      </LinkedAccount>
    </Modal>
  )
}

export default CreateGuardianModal
